var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart-card',{attrs:{"title":_vm.title,"value":_vm.data,"donut-value":_vm.donutValue,"donut-unit":_vm.donutUnit,"unit":"원","isMoveWrite":_vm.isMoveWrite,"orientation":_vm.orientation},on:{"detail":_vm.onClickDetail,"write":_vm.onClickWrite}})
}
var staticRenderFns = []

export { render, staticRenderFns }